import { render } from "./mpmLogo.vue?vue&type=template&id=4e762dca"
import script from "./mpmLogo.vue?vue&type=script&lang=js"
export * from "./mpmLogo.vue?vue&type=script&lang=js"

import "./mpmLogo.vue?vue&type=style&index=0&id=4e762dca&lang=css"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__